/**
 * The one-tap duration presets offered wherever a task or sub-task duration is
 * edited, in minutes. Rendered through `formatTaskDuration`, so these are raw
 * minute values rather than display strings.
 */
export const DURATION_PRESETS = [15, 30, 60, 120, 240] as const;
